import { deleteAPI, getAPI, patchAPI, postAPI, putAPI } from '@/store/api';
import { Action } from '@/store/api/actions';
import { Farm, FarmSensor, FarmSettings } from '@/store/models/farm';

export default new (class FarmAPI {
  public async getAllMyFarms(query = ''): Promise<Farm[]> {
    return await getAPI<Farm[]>(Action.Farms, query);
  }
  public async getFarmById(id: number): Promise<Farm> {
    return await getAPI<Farm>(`${Action.Farms}/${id}`);
  }
  public async getMyDefaultFarm(): Promise<Farm> {
    return await getAPI<Farm>(`${Action.MyDefaultFarm}`);
  }

  public async createFarm(farm: Farm): Promise<Farm> {
    return await postAPI<Farm>(Action.Farms, farm);
  }

  public async updateFarm(farm: Farm): Promise<Farm> {
    return await patchAPI<Farm>(`${Action.Farms}/${farm.id}`, farm);
  }

  public async deleteFarm(id: number): Promise<void> {
    await deleteAPI(`${Action.Farms}/${id}`);
  }

  public async getAllFarmSensor(query = ''): Promise<FarmSensor[]> {
    return await getAPI<FarmSensor[]>(Action.FarmSensor, query);
  }

  public async createFarmSensor(farmSensor: FarmSensor): Promise<FarmSensor> {
    return await postAPI<FarmSensor>(Action.FarmSensor, farmSensor);
  }

  // Every setting of the farm, with the API's own defaults already filled in
  // for the ones never stored, so a caller needs no fallback of its own.
  public async getFarmSettings(farmId: number): Promise<FarmSettings> {
    return await getAPI<FarmSettings>(Action.FarmSettings, `?farm=${farmId}`);
  }

  public async storeFarmSetting(
    farmId: number,
    name: keyof FarmSettings,
    value: string
  ): Promise<void> {
    await putAPI(`${Action.FarmSettings}/${name}`, { farm: farmId, value });
  }
})();
